import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BackdropLoader, ExpandedTooltip, Icon, toast } from '@livable/saas-react-components';
import { Button, Typography, Grid, TextField, FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, FormHelperText } from '@mui/material';
import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import InputMask from 'react-input-mask';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { beforeSubmitDataValidation } from 'src/core/services/beforeSubmitDataValidation';
import { useStore } from 'src/stores';
import { newTeamMemberSchema, newTeamMemberValues } from 'src/utils/formValidation/NewTeamMember';
import { translate } from 'src/utils/translator';
import useStyles from './styles';
export const NewMemberBlock = observer(_ref => {
  let handleModalClose = _ref.handleModalClose,
    isOpenInternal = _ref.isOpenInternal,
    memberType = _ref.memberType,
    teamMemberPage = _ref.teamMemberPage,
    handleEditModalSuccess = _ref.handleEditModalSuccess;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const emailTooltipText = t('add_new_property_flow.invite_to_the_system');
  const newTeamMemberInitialValues = memberType === 'building' ? store.addNewProperty.contactInformation.notSavedNewBuildingTeamMember : store.addNewProperty.contactInformation.notSavedNewUnitTeamMember;
  const handleChangeInputValue = memberType === 'building' ? store.addNewProperty.contactInformation.changeNotSavedNewBuildingTeamMember : store.addNewProperty.contactInformation.changeNotSavedNewUnitTeamMember;
  const formik = useFormik({
    initialValues: teamMemberPage ? newTeamMemberValues : newTeamMemberInitialValues,
    validationSchema: newTeamMemberSchema,
    onSubmit: async values => {
      const phoneCode = store.account.featureFlagsStore.isUkrainianMobileCode ? '+38' : '+1';
      const phoneData = !!values.phone ? {
        phone: "".concat(phoneCode).concat(values.phone)
      } : {
        phone: null
      };
      const data = _objectSpread(_objectSpread({}, phoneData), {}, {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        teamRole: 'PropertyManagerRegular'
      });
      const resp = await store.account.inviteNewUserV2Async.run(beforeSubmitDataValidation(data));
      if (!resp || !resp.isSuccessful) {
        return;
      }
      const newTeamMemberResp = await store.teamMembers.createNewTeamMemberAsync.run({
        accountId: resp.response
      });
      if (!newTeamMemberResp || !newTeamMemberResp.isSuccessful) {
        return;
      }
      if (teamMemberPage) {
        if (handleEditModalSuccess) handleEditModalSuccess();
        toast('success', {
          body: ['Successfully added']
        });
        handleModalClose();
        return;
      }
      const сompanyTeamMembersResp = await store.teamMembers.getCompanyTeamMembersAsync.run({
        companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
      });
      if (сompanyTeamMembersResp && сompanyTeamMembersResp.isSuccessful) {
        if (memberType === 'building') {
          store.addNewProperty.addBuildingContacts(newTeamMemberResp.response);
          store.addNewProperty.contactInformation.resetNotSavedNewBuildingTeamMember();
        } else {
          store.addNewProperty.addUtilitiesContacts(newTeamMemberResp.response);
          store.addNewProperty.contactInformation.resetNotSavedNewUnitTeamMember();
        }
        handleModalClose();
      }
    }
  });
  const customHandleModalClose = () => {
    if (!teamMemberPage) {
      if (memberType === 'building') {
        store.addNewProperty.contactInformation.resetNotSavedNewBuildingTeamMember();
      } else {
        store.addNewProperty.contactInformation.resetNotSavedNewUnitTeamMember();
      }
    }
    handleModalClose();
  };
  useEffect(() => {
    if (!isOpenInternal) {
      if (memberType === 'building') {
        store.addNewProperty.contactInformation.resetNotSavedNewBuildingTeamMember();
      } else {
        store.addNewProperty.contactInformation.resetNotSavedNewUnitTeamMember();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenInternal]);
  return /*#__PURE__*/React.createElement("form", {
    className: classes.form,
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('general.personal_details')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "firstName",
    name: "firstName",
    label: t('general.first_name'),
    variant: "outlined",
    value: formik.values.firstName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
      if (!teamMemberPage) handleChangeInputValue('firstName', e.target.value);
    },
    error: formik.touched.firstName && Boolean(formik.errors.firstName),
    helperText: formik.touched.firstName && translate(formik.errors.firstName, t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "lastName",
    name: "lastName",
    label: t('general.last_name'),
    variant: "outlined",
    value: formik.values.lastName,
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
      if (!teamMemberPage) handleChangeInputValue('lastName', e.target.value);
    },
    error: formik.touched.lastName && Boolean(formik.errors.lastName),
    helperText: formik.touched.lastName && translate(formik.errors.lastName, t)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true,
    error: formik.touched.email && Boolean(formik.errors.email),
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: e => {
      formik.handleChange(e);
      if (!teamMemberPage) handleChangeInputValue('email', e.target.value);
    }
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "email"
  }, t('general.email_address')), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "email",
    type: "email",
    label: t('general.email_address'),
    value: formik.values.email,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end",
      type: "infoTooltip"
    }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
      placement: "top",
      title: emailTooltipText,
      type: "grey"
    }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
      type: "question"
    }))))
  }), formik.touched.email && !!formik.errors.email && /*#__PURE__*/React.createElement(FormHelperText, null, translate(formik.errors.email, t)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(InputMask, {
    mask: "999-999-9999",
    value: formik.values.phone,
    onChange: e => {
      formik.handleChange(e);
      if (!teamMemberPage) handleChangeInputValue('phone', e.target.value);
    },
    onBlur: e => {
      if (!formik.touched.phone && /\d/.test(e.target.value)) formik.setFieldTouched('phone', true);
    }
  }, inputProps => /*#__PURE__*/React.createElement(TextField, _extends({}, inputProps, {
    type: "tel",
    fullWidth: true,
    id: "phone",
    name: "phone",
    variant: "outlined",
    label: t('general.phone_number_optional'),
    error: formik.touched.phone && Boolean(formik.errors.phone),
    helperText: formik.touched.phone && translate(formik.errors.phone, t)
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: classes.formFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    type: "button",
    onClick: customHandleModalClose,
    'custom-attribute': '294-new-member-block'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "text",
    disabled: !formik.isValid || !Object.keys(formik.touched).length || store.account.inviteNewUserV2Async.inProgress || store.teamMembers.createNewTeamMemberAsync.inProgress,
    'custom-attribute': '295-new-member-block'
  }, t('add_new_property_flow.add_team_member')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.account.inviteNewUserV2Async.inProgress || store.teamMembers.createNewTeamMemberAsync.inProgress
  }));
});